export const apiV1Path = '/api/v1';
export const DEFAULT_ERROR = 'Something went wrong. Please try again later.';
export const TYPE_ERROR = 'Error: incorrect received data format.';
